'use client'

import { useSyncExternalStore } from 'react'
import { hasLeadMagnetUnlockCookie, subscribeLeadMagnetUnlock } from '../utils/lead-magnet-unlock'

/** Unlock state for gated tools; false during SSR, re-renders when any gate unlocks. */
export function useLeadMagnetUnlocked(slug: string): boolean {
  return useSyncExternalStore(
    subscribeLeadMagnetUnlock,
    () => hasLeadMagnetUnlockCookie(slug),
    () => false
  )
}
